import { Component, OnInit, ViewChild, ViewEncapsulation } from "@angular/core";
import { NavigationEnd, Router } from "@angular/router";
import { ToastContainerDirective, ToastrService } from "ngx-toastr";
import { FeatureContextService } from "@/_services/feature-context.service";

@Component({
    selector: "app-root",
    encapsulation: ViewEncapsulation.None,
    styleUrls: ["app.component.scss", "../assets/css/core.scss"],
    templateUrl: "./app.component.html",
})
export class AppComponent implements OnInit {
    title = "Preflight";

    @ViewChild(ToastContainerDirective, { static: true })
    toastContainer: ToastContainerDirective;

    constructor(
        private router: Router,
        private toastService: ToastrService,
        // Injected to force eager initialization so context is set on first load
        _featureContext: FeatureContextService,
    ) {}

    ngOnInit() {
        this.toastService.overlayContainer = this.toastContainer;

        this.router.events.subscribe((event) => {
            if (event instanceof NavigationEnd) {
                if (document.scrollingElement) {
                    document.scrollingElement.scrollTop = 0;
                }
            }
        });
    }
}
